import { IBoardColumnType, IBoardType } from '@introspection/index';
import { matching, mod } from 'shades';

export const matchingId = (id: string) => matching<{ id?: string }>({ id });

export const modColumns = () => (callback: (cards: IBoardColumnType[]) => IBoardColumnType[]) =>
  mod('columns')(callback);

export const addColumnToState = () => (column: IBoardColumnType) => modColumns()((columns) => [...columns, column]);

export const updateColumnToState = () => (column: IBoardColumnType) =>
  modColumns()((columns) => {
    const index = columns.findIndex((c) => c.id === column.id);
    columns[index] = column;
    return [...columns];
  });

export const removeColumnFromState = () => (column: IBoardColumnType) =>
  modColumns()((columns) => columns.filter((c) => c.id !== column.id));

export const modBoards = () => (callback: (boards: IBoardType[]) => IBoardType[]) => mod('boards')(callback);

export const addBoardToState = () => (board: IBoardType) => modBoards()((boards) => [...boards, board]);

export const deleteBoardToState = () => (board: IBoardType) =>
  modBoards()((boards) => boards.filter((b) => b.id !== board.id));
